<h2 matDialogTitle class="mat-h2">Create Ad</h2>

<mat-dialog-content class="mat-body-2">
  <mat-divider></mat-divider>
  <mat-stepper #stepper labelPosition="bottom" class="blue" orientation="vertical">
    <mat-step [stepControl]="adFormGroup" errorMessage="Input is invalid">
      <ng-template matStepLabel>Ad Details</ng-template>
      <div class="ad-type">
        <mat-radio-group [formControl]="adType" aria-label="Select Ad Type">
          <mat-radio-button value="text">Text Ad</mat-radio-button>
          <mat-radio-button value="banner">Banner Ad</mat-radio-button>
        </mat-radio-group>
      </div>
      <div [style.display]="(adType$ | async) === 'text' ? null : 'none'">
        <form [formGroup]="textAdFormGroup">
          <div class="text-ad-div">
            <mat-form-field floatLabel="always">
              <mat-label>Ad Text</mat-label>
              <input matInput placeholder="This is what customers see" formControlName="textAdLinkText">
              <mat-error>{{textAdFormControls.textAdLinkText.errors | validationMessage}}</mat-error>
            </mat-form-field>
            <mat-form-field floatLabel="always">
              <mat-label>Ad Name</mat-label>
              <input matInput placeholder="For internal reporting" formControlName="textAdName">
              <mat-error>{{textAdFormControls.textAdName.errors | validationMessage}}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Destination URL</mat-label>
              <input formControlName="destinationUrl" matInput placeholder="This is the ad destination">
              <mat-error>{{textAdFormControls.destinationUrl.errors | validationMessage}}</mat-error>
            </mat-form-field>
          </div>
        </form>
      </div>

      <div [style.display]="(adType$ | async) === 'banner' ? null : 'none'">
        <div #dropZone class="drop-zone" [class.drag-hover]="hoveringInDropZone$ | async">
          <input #fileInput type="file" accept=".jpg,.png,.jpeg,.gif" multiple style="display:none"
                 (change)="fileInput$.next($event)">
          <mat-icon color="accent">cloud_upload</mat-icon> &nbsp; Drop files to upload, or <a
          (click)="fileInput.click()">browse</a> (limit 20 images).
        </div>
        <form [formGroup]="bannerAdFormGroup">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z1" formArrayName="banners">
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td mat-cell
                  *matCellDef="let banner; let i = index"> {{i + 1}} </td>
            </ng-container>

            <ng-container matColumnDef="bannerAdImageFile">
              <th mat-header-cell *matHeaderCellDef>Ad Image</th>
              <td mat-cell *matCellDef="let banner; "> {{banner.bannerAdImageFile.name}} </td>
            </ng-container>

            <ng-container matColumnDef="bannerAdName">
              <th mat-header-cell *matHeaderCellDef>Ad Name</th>
              <td mat-cell *matCellDef="let banner; let i = index"
                  [formGroupName]="i">
                <mat-form-field>
                  <mat-label>Ad Name</mat-label>
                  <input matInput placeholder="For internal reporting" formControlName="bannerAdName">
                  <mat-error>{{bannerAdFormControls.banners.at(i).get('bannerAdName').errors | validationMessage}}</mat-error>
                </mat-form-field>
              </td>
            </ng-container>

            <ng-container matColumnDef="deleteBannerAd">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element; let i = index">
                <button mat-icon-button type="button"
                        (click)="onDeleteBannerRowClick(i)">
                  <mat-icon>clear</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-form-field>
            <mat-label>Destination URL</mat-label>
            <input formControlName="destinationUrl" matInput placeholder="This is the ad destination">
            <mat-error>{{textAdFormControls.destinationUrl.errors | validationMessage}}</mat-error>
          </mat-form-field>
        </form>
      </div>
      <button mat-raised-button color="primary" matStepperNext>Next</button>
    </mat-step>
    <mat-step [stepControl]="adScheduleFormGroup" errorMessage="Input is invalid">
      <form [formGroup]="adScheduleFormGroup">
        <ng-template matStepLabel>Ad Schedule</ng-template>
        <div class="form-field-row">
          <mat-form-field>
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            <mat-error *ngIf="adScheduleFormControls.startDate.hasError('matDatepickerParse')">Please enter a valid
              date.
            </mat-error>
            <mat-error
              *ngIf="!adScheduleFormControls.startDate.hasError('matDatepickerParse')">{{adScheduleFormControls.startDate.errors | validationMessage}}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Start Time</mat-label>
            <mat-select formControlName="startTime">
              <mat-option *ngFor="let option of hourTimeOptions" [value]="option.value">{{option.label}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-field-row">
          <mat-form-field floatLabel="always">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" placeholder="No end date">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
            <mat-hint>Leave blank for no end date</mat-hint>
            <mat-error>{{adScheduleFormControls.endDate.errors | validationMessage}}</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>End Time</mat-label>
            <mat-select formControlName="endTime" [disabled]="adScheduleFormGroup.get('endDate').value == null">
              <mat-option *ngIf="adScheduleFormGroup.get('endDate').value == null" [value]="-1">N/A</mat-option>
              <mat-option *ngFor="let option of hourTimeOptions" [value]="option.value">{{option.label}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <button mat-button class="back-button" matStepperPrevious>Back</button>
          <button mat-raised-button color="primary" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <form [formGroup]="affiliateDesignationFormGroup">
        <ng-template matStepLabel>Affiliate Designation</ng-template>
        <div class="form-field-row">
          <mat-form-field floatLabel="always">
            <mat-label>Affiliate Designation</mat-label>
            <input type="text"
                   placeholder="Affiliate Name, URL, Classic ID, Tag Group"
                   aria-label="Affiliate Designation"
                   matInput
                   formControlName="exclusiveFilter"
                   [matAutocomplete]="exclusiveAuto"
                    #exclusiveInput>
            <mat-autocomplete #exclusiveAuto="matAutocomplete" [displayWith]="exclusiveFilterDisplayWith"
                              (optionSelected)="exclusiveFilterAutoCompleteOnSelected($event, exclusiveInput)" (opened)="autoSelectOnOpened(affiliateDesignationFormControls.exclusiveFilter)" (closed)="exclusiveFilterAutoCompleteOnClosed()">
              <mat-option [value]="allAffiliatesOption" class="autocomplete-option">{{allAffiliatesOption.affiliate_name}}</mat-option>
              <mat-option *ngFor="let affiliateOption of affiliateFilteredOptionsLimited$ | async" class="autocomplete-option" [value]="affiliateOption">
                <div class="mat-subtitle-2">{{affiliateOption.affiliate_name}}</div>
                <div class="mat-body-2">{{affiliateOption.affiliate_website_url_protocol_stripped}}</div>
                <span class="circle circle-green">&nbsp;</span>
                <span><mat-icon [svgIcon]="affiliateOption.affiliate_network"></mat-icon></span>
                <span class="classic-id mat-caption">{{affiliateOption.classic_affiliate_id}}</span>
              </mat-option>
              <mat-divider></mat-divider>
              <mat-optgroup [label]="'Tag Groups'">
                <mat-option *ngFor="let tagOption of userTagFilteredOptionsLimited$ | async" class="autocomplete-tag-option" [value]="tagOption">
                  <span><mat-icon aria-hidden="false" aria-label="Tag Group icon" color="accent">groups</mat-icon></span><span class="mat-body-2">{{tagOption.tag_name | titlecase}}</span>
                </mat-option>
              </mat-optgroup>
              <mat-option *ngIf="(affiliateFilteredOptions$ | async)?.length > exclusiveAffiliateLimit || (userTagFilteredOptions$ | async)?.length > exclusiveTagLimit" [disabled]="true" class="autocomplete-option">
                <p class="mat-subtitle-2">Filter to see more results.</p>
              </mat-option>
            </mat-autocomplete>
            <mat-hint>Designate affiliates that can use ad</mat-hint>
          </mat-form-field>
        </div>
        <div>
          <button mat-button class="back-button" matStepperPrevious>Back</button>
          <button mat-raised-button color="primary"
                  [disabled]="!adFormGroup.valid || !adScheduleFormGroup.valid || !affiliateDesignationFormGroup.valid || disableSaveButton"
                  (click)="saveClick$.next(undefined)">{{disableSaveButton ? 'Saving...' : 'Save'}}
          </button>
          <button mat-raised-button *ngIf="adType.value === 'text'"
                  [disabled]="!adFormGroup.valid || !adScheduleFormGroup.valid || !affiliateDesignationFormGroup.valid"
                  color="accent" style="float: right" (click)="onPreviewClick()">Preview</button>
        </div>
      </form>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
